(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  /* =========================================================
     STICKY HEADER
     ---------------------------------------------------------
     Header:
     - ALWAYS sticky
     - Never hides on scroll
     - Search bar is controlled separately below
     ========================================================= */

  class StickyHeader extends HTMLElement {

    constructor() {
      super();

      this.header = null;
      this.predictiveSearch = null;

      this.currentScrollTop = 0;
      this.headerBounds = {};

      this.resizeHandler = null;
      this.onScrollHandler = null;
      this.hideHeaderOnScrollUp = null;
    }


    /* =======================================================
       CONNECTED
       ======================================================= */

    connectedCallback() {

      this.header =
        document.querySelector('.section-header');

      if (!this.header) return;


      /*
       * Header is ALWAYS sticky.
       */
      this.headerIsAlwaysSticky = true;


      /*
       * Set header height.
       */
      this.setHeaderHeight();


      /*
       * Update header height when viewport changes.
       */
      this.resizeHandler =
        this.setHeaderHeight.bind(this);

      window.addEventListener(
        'resize',
        this.resizeHandler,
        { passive: true }
      );


      /*
       * Make header sticky immediately.
       */
      this.header.classList.add(
        'shopify-section-header-sticky'
      );


      /*
       * Predictive search.
       *
       * IMPORTANT:
       * Search is outside sticky-header,
       * therefore search the entire document.
       */
      this.predictiveSearch =
        document.querySelector(
          '.persistent-header-search predictive-search'
        );


      /*
       * Scroll handling for HEADER only.
       *
       * The header itself does NOT hide.
       */
      this.onScrollHandler =
        this.onScroll.bind(this);

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        { passive: true }
      );


      /*
       * Shopify compatibility.
       */
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      /*
       * Get original header position.
       */
      this.createObserver();
    }


    /* =======================================================
       HEADER HEIGHT
       ======================================================= */

    setHeaderHeight() {

      if (!this.header) return;

      /*
       * Use the actual header element height.
       */
      const height =
        this.header.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${height}px`
      );


      /*
       * Tell the search controller that
       * the header size changed.
       */
      window.dispatchEvent(
        new CustomEvent('persistent-search-position-update')
      );
    }


    /* =======================================================
       CLEANUP
       ======================================================= */

    disconnectedCallback() {

      if (this.onScrollHandler) {

        window.removeEventListener(
          'scroll',
          this.onScrollHandler
        );
      }


      if (this.resizeHandler) {

        window.removeEventListener(
          'resize',
          this.resizeHandler
        );
      }


      if (this.hideHeaderOnScrollUp) {

        this.removeEventListener(
          'preventHeaderReveal',
          this.hideHeaderOnScrollUp
        );
      }
    }


    /* =======================================================
       INTERSECTION OBSERVER
       ======================================================= */

    createObserver() {

      if (!this.header) return;


      const observer =
        new IntersectionObserver(
          (entries, observer) => {

            if (
              entries &&
              entries[0]
            ) {

              this.headerBounds =
                entries[0].intersectionRect;
            }

            observer.disconnect();
          }
        );


      observer.observe(this.header);
    }


    /* =======================================================
       HEADER SCROLL
       -------------------------------------------------------
       The header stays sticky.
       We DO NOT hide the header.
       ======================================================= */

    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0;


      /*
       * Predictive search is open.
       * Don't interfere with Shopify.
       */
      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {

        this.currentScrollTop =
          scrollTop;

        return;
      }


      /*
       * Mark that the page has moved past
       * the original header position.
       */
      if (
        scrollTop >
        this.currentScrollTop
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

      } else if (
        scrollTop <
        this.currentScrollTop
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

      } else if (
        scrollTop <= 10
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );
      }


      /*
       * Header ALWAYS remains sticky.
       */
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );


      this.currentScrollTop =
        scrollTop;
    }


    /* =======================================================
       SHOPIFY COMPATIBILITY
       -------------------------------------------------------
       These methods are intentionally harmless because
       your header is ALWAYS sticky.
       ======================================================= */

    hide() {

      /*
       * DO NOT hide the header.
       */
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );
    }


    reveal() {

      /*
       * Keep header visible.
       */
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );
    }


    reset() {

      /*
       * Keep header visible and sticky.
       */
      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      this.header.classList.add(
        'shopify-section-header-sticky'
      );
    }


    /* =======================================================
       CLOSE MENU
       ======================================================= */

    closeMenuDisclosure() {

      if (!this.header) return;

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) => {

          if (
            disclosure &&
            typeof disclosure.close === 'function'
          ) {

            disclosure.close();
          }
        }
      );
    }


    /* =======================================================
       CLOSE SEARCH MODAL
       ======================================================= */

    closeSearchModal() {

      if (!this.header) return;

      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      if (
        this.searchModal &&
        typeof this.searchModal.close === 'function'
      ) {

        this.searchModal.close(false);
      }
    }
  }


  /*
   * Prevent duplicate custom-element registration
   * when Shopify Theme Editor reloads the section.
   */
  if (!customElements.get('sticky-header')) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }



  /* =========================================================
     PERSISTENT SEARCH
     ---------------------------------------------------------
     Search:
     - Fixed below header
     - Visible at top
     - Hides when scrolling DOWN
     - Shows when scrolling UP
     - Never changes header behaviour
     ========================================================= */

  class PersistentSearchScroll {

    constructor() {

      this.search =
        document.querySelector(
          '.persistent-header-search'
        );

      if (!this.search) return;


      this.header =
        document.querySelector(
          'sticky-header'
        );


      /*
       * Scroll state.
       */
      this.lastScrollY =
        window.scrollY || 0;

      this.ticking = false;


      /*
       * Small movement threshold prevents
       * the search from flickering.
       */
      this.scrollThreshold = 2;


      /*
       * Bind functions.
       */
      this.scrollHandler =
        this.handleScroll.bind(this);

      this.resizeHandler =
        this.updateSearchPosition.bind(this);

      this.positionUpdateHandler =
        this.updateSearchPosition.bind(this);


      /*
       * Calculate correct position IMMEDIATELY.
       *
       * This is the important fix for the
       * first page load.
       */
      this.updateSearchPosition();


      /*
       * Scroll listener.
       */
      window.addEventListener(
        'scroll',
        this.scrollHandler,
        { passive: true }
      );


      /*
       * Resize listener.
       */
      window.addEventListener(
        'resize',
        this.resizeHandler,
        { passive: true }
      );


      /*
       * Listen for header height changes.
       */
      window.addEventListener(
        'persistent-search-position-update',
        this.positionUpdateHandler
      );


      /*
       * Run once after the page has fully rendered.
       *
       * This catches logo/header size changes
       * that happen shortly after page load.
       */
      requestAnimationFrame(() => {
        this.updateSearchPosition();
      });

      setTimeout(() => {
        this.updateSearchPosition();
      }, 100);
    }


    /* =======================================================
       SEARCH POSITION
       -------------------------------------------------------
       THIS IS THE IMPORTANT PART.
       
       Instead of assuming that --header-height is correct,
       we measure the REAL bottom of sticky-header.
       
       Search therefore always sits directly underneath it.
       ======================================================= */

    updateSearchPosition() {

      if (!this.search) return;


      const header =
        document.querySelector(
          'sticky-header'
        );

      if (!header) return;


      /*
       * getBoundingClientRect().bottom gives us
       * the REAL visible bottom edge of the sticky header.
       *
       * This works correctly:
       * - on first page load
       * - after scrolling
       * - on mobile
       * - on desktop
       * - when header height changes
       */
      const headerRect =
        header.getBoundingClientRect();


      const headerBottom =
        Math.max(
          0,
          headerRect.bottom
        );


      /*
       * 8px AIR / GAP between header and search.
       *
       * Change 8 to 6, 10, 12 etc. if desired.
       */
      const searchGap = 8;


      /*
       * Store the exact fixed position.
       */
      document.documentElement.style.setProperty(
        '--persistent-search-top',
        `${headerBottom + searchGap}px`
      );
    }


    /* =======================================================
       SEARCH SCROLL
       ======================================================= */

    handleScroll() {

      if (this.ticking) return;


      this.ticking = true;


      window.requestAnimationFrame(() => {

        const currentScrollY =
          window.scrollY || 0;


        /* ===================================================
           TOP OF PAGE
           ---------------------------------------------------
           Search MUST be visible.
           =================================================== */

        if (currentScrollY <= 10) {

          this.search.classList.remove(
            'search-hidden'
          );


          this.lastScrollY =
            currentScrollY;


          this.ticking = false;

          /*
           * Recalculate position at top.
           */
          this.updateSearchPosition();

          return;
        }


        /* ===================================================
           SCROLLING DOWN
           ---------------------------------------------------
           Hide ONLY the search.
           Header remains sticky.
           =================================================== */

        if (
          currentScrollY >
          this.lastScrollY +
          this.scrollThreshold
        ) {

          this.search.classList.add(
            'search-hidden'
          );
        }


        /* ===================================================
           SCROLLING UP
           ---------------------------------------------------
           Show ONLY the search.
           =================================================== */

        else if (
          currentScrollY <
          this.lastScrollY -
          this.scrollThreshold
        ) {

          this.search.classList.remove(
            'search-hidden'
          );


          /*
           * Recalculate its position when it returns.
           */
          this.updateSearchPosition();
        }


        /*
         * Save current position.
         */
        this.lastScrollY =
          currentScrollY;


        this.ticking = false;
      });
    }


    /* =======================================================
       CLEANUP
       ======================================================= */

    disconnectedCallback() {

      window.removeEventListener(
        'scroll',
        this.scrollHandler
      );


      window.removeEventListener(
        'resize',
        this.resizeHandler
      );


      window.removeEventListener(
        'persistent-search-position-update',
        this.positionUpdateHandler
      );
    }
  }


  /* =========================================================
     START SEARCH CONTROLLER
     ========================================================= */

  /*
   * Prevent duplicate initialization when Shopify
   * reloads the section in the Theme Editor.
   */
  if (
    !window.__persistentSearchScrollInitialized
  ) {

    window.__persistentSearchScrollInitialized = true;

    window.__persistentSearchScroll =
      new PersistentSearchScroll();
  }


  } catch(e) { console.error(e); }
})();
})();
